import axios from 'axios';

const apiClient = axios.create({
  baseURL: '',  // 使用空字符串，让浏览器自动使用当前域名
  headers: {
    'Content-Type': 'application/json',
  },
});

// 请求拦截器：自动添加 token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('memo_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // 如果请求的是API端点，确保以/api开头
    if (config.url && !config.url.startsWith('/api') && !config.url.startsWith('http')) {
      config.url = `/api${config.url.startsWith('/') ? '' : '/'}${config.url}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器：处理错误 - 修改版
// 请求拦截器：自动添加 token 和修复路径
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('memo_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // 修复：确保API请求以/api开头
    if (config.url && !config.url.startsWith('http')) {
      // 如果已经是/api开头，保持原样
      if (!config.url.startsWith('/api')) {
        config.url = `/api${config.url.startsWith('/') ? '' : '/'}${config.url}`;
      }
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default apiClient;
// 新增：游戏相关 API
export const gameAPI = {
    getStats: () => apiClient.get('/game/stats'),
    getLeaderboard: () => apiClient.get('/leaderboard'),
    updateHighScore: (score) => apiClient.post('/game/update_high_score', { score }),
    getHistory: (page = 1, perPage = 10) => apiClient.get(`/game/history?page=${page}&per_page=${perPage}`),
};